/**
 * URL base da API do PharuERP — FONTE ÚNICA.
 *
 * Por que existe: até 2026-07 a URL do backend estava duplicada em 10 arquivos,
 * cada um com sua própria lógica de fallback — e três variações diferentes
 * coexistiam. Pior: parte delas caía, em produção, num proxy `/access-api` que
 * o `vercel.json` reescrevia para um host da Railway DESCOMISSIONADO desde
 * 2026-05-20. Ou seja: um build de produção sem `REACT_APP_ACCESS_API_URL`
 * conversava com um servidor que não existe mais.
 *
 * Regra: NINGUÉM lê `process.env.REACT_APP_ACCESS_API_URL` direto. Importe
 * `ACCESS_API_URL` daqui. Assim, trocar de backend é mexer em UM lugar.
 *
 * Como configurar:
 *   - Produção: `REACT_APP_ACCESS_API_URL` no `.env.production`, lido no build
 *     (`yarn build`); o bundle vai para o S3 e é servido pelo CloudFront, e a
 *     API responde em `api.pharu.com.br` (Lightsail).
 *   - Local: `.env.local` na raiz do frontend com
 *     `REACT_APP_ACCESS_API_URL=http://localhost:8000` (ele vence o
 *     `.env.production` também no build: não deixe um apontando para localhost
 *     na hora de gerar o bundle de produção).
 *
 * ATENÇÃO (CRA): `REACT_APP_*` é resolvida em tempo de BUILD, não em runtime —
 * mudar o valor exige novo build. É exatamente por isso que a migração para a
 * AWS aponta um domínio próprio (`api.pharu.com.br`) para o backend: com o
 * domínio no meio, trocar de servidor vira uma alteração de DNS, sem rebuild
 * do frontend nem risco de ficar preso a um endereço antigo.
 */

// Rede de segurança para quando a variável não está definida. Precisa apontar
// para o backend ATUAL — nunca para um host morto.
//
// Atualizado 2026-08-04: apontava para `dashpcp-access-api.onrender.com`, que
// foi SUSPENSO na migração para a AWS e hoje responde 503. O comentário
// original já dizia "nunca para um host morto", mas o valor tinha envelhecido
// junto com a infraestrutura — um build sem a variável cairia num endereço
// desligado. Agora aponta para o domínio próprio, que sobrevive a trocas de
// servidor porque o que muda é o DNS, não o bundle.
const FALLBACK_BACKEND = "https://api.pharu.com.br";

export const ACCESS_API_URL = (
  process.env.REACT_APP_ACCESS_API_URL || FALLBACK_BACKEND
).replace(/\/$/, "");

if (typeof process !== "undefined" && !process.env.REACT_APP_ACCESS_API_URL) {
  const mensagem = process.env.NODE_ENV === "production"
    ? `[PharuERP] REACT_APP_ACCESS_API_URL não definida no build de produção — usando fallback ${ACCESS_API_URL}. Defina a variável no .env.production antes do build.`
    : `[PharuERP] REACT_APP_ACCESS_API_URL não definida — usando fallback ${ACCESS_API_URL}. Crie o .env.local na raiz do frontend para apontar a outro backend.`;
  // Em produção isso é um defeito de configuração: grita como erro.
  // eslint-disable-next-line no-console
  (process.env.NODE_ENV === "production" ? console.error : console.warn)(mensagem);
}

export default ACCESS_API_URL;
